import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["type", "id", "disabled", "placeholder", "required", "maxlength", "minlength"];
import { ref } from "vue";
import Icon from "../Icon.vue";
import { toText } from "./fieldValues";
import { useFieldControl, useFieldModel } from "./useFieldControl";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlPassword',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur',
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const { fieldOptions, emitChange, onFocus, onBlur } = useFieldControl(props, emit, 'FieldControlPassword');
        const model = useFieldModel(() => toText(props.data));
        const revealed = ref(false);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["form__control secret", { 'form__control--empty': !_unref(model) }])
            }, [
                _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(model) ? (model).value = $event : null)),
                    onInput: _cache[1] || (_cache[1] = ($event) => (_unref(emitChange)(_unref(model) || null))),
                    onFocus: _cache[2] || (_cache[2] =
                        //@ts-ignore
                        (...args) => (_unref(onFocus) && _unref(onFocus)(...args))),
                    onBlur: _cache[3] || (_cache[3] =
                        //@ts-ignore
                        (...args) => (_unref(onBlur) && _unref(onBlur)(...args))),
                    type: revealed.value ? 'text' : 'password',
                    id: __props.fieldId,
                    disabled: _unref(fieldOptions).disabled ?? undefined,
                    placeholder: _unref(fieldOptions).placeholder ?? undefined,
                    required: _unref(fieldOptions).required ?? undefined,
                    maxlength: _unref(fieldOptions).maxLength ?? undefined,
                    minlength: _unref(fieldOptions).minLength ?? undefined,
                    autocomplete: "off",
                    "data-1p-ignore": "",
                    class: "secret__input"
                }, null, 40, _hoisted_1), [
                    [_vModelDynamic, _unref(model)]
                ]),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createVNode(Icon, {
                    name: revealed.value ? 'lock-open' : 'lock',
                    class: "secret__icon",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (revealed.value = !revealed.value), ["prevent"]))
                }, null, 8, ["name"])
            ], 2));
        };
    }
});
